import { clientId } from "./constants";
import "./propertyRenderers";
import "./ticketViews";

export const processMiningRoutes = [
  {
    path: "/process-mining",
    name: "pmOverview",
    component: () => import("./views/ProcessMiningOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
      ],
    },
  },
  {
    path: "/process-mining/logs",
    name: "pmLogs",
    component: () => import("./views/PMEventLogs.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "processLogs",
          route: { name: "pmLogs" },
        },
      ],
    },
  },
  {
    path: "/process-mining/logs/:id",
    name: "pmLogDetails",
    props: true,
    component: () => import("./views/PMEventLogDetails.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "processLogs",
          route: { name: "pmLogs" },
        },
      ],
    },
  },
  {
    path: "/process-mining/workbench/:eventLogId",
    name: "pmWorkbench",
    props: true,
    component: () => import("./views/PMProcessWorkbench.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "workbench",
          route: { name: "pmWorkbench" },
        },
      ],
    },
  },
  {
    path: "/process-mining/logs/:eventId/analysis/:analysisId",
    name: "pmAnalysisDetails",
    props: true,
    component: () => import("./views/PMEventLogAnalysis.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "processLogs",
          route: { name: "pmLogs" },
        },
      ],
    },
  },

  {
    path: "/process-mining/dashboards",
    name: "pmDashboardList",
    component: () => import("./views/PMDashboardList.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "dashboard",
          route: { name: "pmDashboardList" },
        },
      ],
    },
  },
  {
    path: "/process-mining/dashboards/:dashboardId",
    name: "pmDashboardDetail",
    component: () => import("./views/PMDashboardDetail.vue"),
    props: true,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "dashboard",
          route: { name: "pmDashboardList" },
        },
        {
          label: "detail",
          route: { name: "pmDashboardDetail" },
        },
      ],
    },
  },
  {
    path: "/process-mining/data-quality",
    name: "pmDataQuality",
    component: () => import("./views/DataQualityDatabases.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "dataQuality",
          route: { name: "pmDataQuality" },
        },
      ],
    },
  },
  {
    path: "/process-mining/data-quality/tickets/:id",
    name: "pmDataQualityTicketDetail",
    props: true,
    component: () => import("./views/DataQualityTicketDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "pmMyTickets" },
        },
      ],
    },
  },
  {
    path: "/process-mining/data-quality/ticket-history/:id",
    name: "pmDataQualityTicketHistory",
    props: true,
    component: () => import("./views/DataQualityTicketHistory.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "pmMyTickets" },
        },
      ],
    },
  },
  {
    path: "/process-mining/my-tickets",
    name: "pmMyTickets",
    props: true,
    component: () => import("./views/PMMyTickets.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "myTickets",
          route: { name: "pmMyTickets" },
        },
      ],
    },
  },
  {
    path: "/process-mining/data-quality/:databaseId",
    name: "pmDataQualityTable",
    props: true,
    component: () => import("./views/DataQualityTables.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "dataQuality",
          route: { name: "pmDataQuality" },
        },
      ],
    },
  },
  {
    path: "/process-mining/data-quality/:databaseId/schedules/:scheduleId",
    name: "pmDataQualityTableScheduleRuns",
    props: true,
    component: () => import("./views/DataQualityAnalysisScheduleRuns.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "dataQuality",
          route: { name: "pmDataQuality" },
        },
      ],
    },
  },
  {
    path: "/process-mining/data-quality/:databaseId/:tableId",
    name: "pmDataQualityTableDetails",
    props: true,
    component: () => import("./views/DataQualityTableDetails.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "processMining",
          route: { name: "pmOverview" },
        },
        {
          label: "dataQuality",
          route: { name: "pmDataQuality" },
        },
      ],
    },
  },
];
